import { useEffect, useState } from 'react';
import { Cradle } from '@solo/app-core';
import { Flex, Text } from '@/app/ui/atoms';
import { CustomBarChart, InputTextAutocomplete } from '@/app/ui';
// import { platforms } from '@/app/ui/organisms/Plays/PlaysByPlatform';
import Colors from '@/app/styles/Colors';
import { useCradle } from '@/app/contexts';
import { BarData } from '@/app/ui/organisms/CustomBarChart/CustomBarChart';
import { spanFilters, TimeSpan } from '@/app/utils/GetDateFrom';
import { translate } from '@/app/i18n';

export type UsageData = {
  [key: string]: number;
};

const TopSongsPlatform = () => {
  const { statisticsBloc } = useCradle<Cradle>();
  const [usagesData, setUsagesData] = useState<BarData[][]>([]);

  // const digitalPlatforms =
  //   digitalDistributionState.kind === 'LoadedDigitalDistributionState'
  //     ? digitalDistributionState.platforms
  //     : [];

  async function getTopSongs({ period, platform }: { period?: string; platform?: string }) {
    let p: 'last_month' | 'this_year' | 'last_year' | undefined;
    if (period && period === TimeSpan.lastMonth) {
      p = 'last_month';
    } else if (period && period === TimeSpan.lastYear) {
      p = 'last_year';
    } else if (period && period === TimeSpan.thisYear) {
      p = 'this_year';
    }

    const plays = await statisticsBloc.getPlays({
      limit: 6,
      period: p,
      platform,
    });

    const data = plays.map((play) => ({
      x: play.trackName,
      y: play.plays,
    }));

    if (data.length > 0) {
      setUsagesData([data]);
    } else {
      setUsagesData([]);
    }
  }

  useEffect(() => {
    getTopSongs({});
  }, []);

  return (
    <Flex.Container flexDirection="column" className="mt-5" gap="2.5rem">
      <Flex.Container style={{ width: '41%' }} gap="1rem">
        {/* <InputTextAutocomplete
          placeholder="Platform..."
          items={[{ value: 'All', label: 'All' }].concat(
            digitalPlatforms.map((p) => ({ value: p.id.toString(), label: p.name })),
          )}
          onChange={(groupFilter) =>
            groupFilter === 'All' ? getTopSongs({}) : getTopSongs({ platform: groupFilter })
          }
        /> */}
        <InputTextAutocomplete
          items={spanFilters}
          onChange={(filter) => getTopSongs({ period: filter })}
        />
      </Flex.Container>
      {usagesData.length > 0 && (
        <CustomBarChart yaxis="Plays" data={usagesData} barColors={[Colors.primary]} />
      )}
      {usagesData.length === 0 && <Text.Anotation>{translate('USAGES.NO_DATA')}</Text.Anotation>}
    </Flex.Container>
  );
};

export default TopSongsPlatform;
